module.exports = __webpack_public_path__ + "static/media/right-arrow.c4ca529e.svg";